import { RiWhatsappLine } from "react-icons/ri";
import { FiShoppingCart } from "react-icons/fi";

import { ButtonHref } from "../../../components/elements/button";
import SectionTitle from "../../../components/elements/section-title";
import FeatureStrip from "../../../components/elements/feature-strip";
import ServiceHero from "../../../components/elements/service-hero";
import "../ep-courses-and-services-pages.css";
import CTA from "../../../components/elements/CTA";
import InfoContractingTermsConditions from "../../../components/elements/button/info-contracting-terms-conditions";
import { whatsAppRedirect } from "../../../hooks/common";

const services = [
  {
    icon: "▥",
    title: "Redação ENEM",
    subtitle: "Seu futuro começa com uma boa redação.",
    desc: "Preparação completa para a Redação do ENEM, com foco nas competências avaliadas, estrutura textual e desenvolvimento de repertório.",
    price: "89,90",
    unit: "/mês",
    features: [
      "Aulas online",
      "Correções de redação",
      "Estratégias para a prova",
      "Simulados e acompanhamento",
    ],
    href: "/redacao-enem",
  },
  {
    icon: "▤",
    title: "Correções para Concursos",
    subtitle: "Sua redação no nível que o edital exige.",
    desc: "Correção criteriosa e personalizada para concursos, com foco nas exigências de cada edital e banca examinadora.",
    price: "129,90",
    unit: "/mês",
    features: [
      "Análise conforme o edital",
      "Exercícios práticos",
      "Correção de textos",
      "Estratégias de prova",
    ],
  },
  {
    icon: "♧",
    title: "Produção Textual para Vestibulares",
    subtitle: "Mais clareza, mais segurança, mais aprovação.",
    desc: "Treinamento para a produção textual exigida nos principais vestibulares, com foco em estrutura, coesão e argumentação.",
    price: "349,90",
    unit: "/mês",
    features: [
      "Produção textual voltada para vestibulares",
      "Correções e feedback",
      "Exercícios de escrita",
      "Estratégias de prova",
    ],
  },
  {
    icon: "♙",
    title: "Mentorias Individuais",
    subtitle: "Um plano feito especialmente para você.",
    desc: "Acompanhamento personalizado para quem deseja evoluir com mais foco, direcionamento e suporte contínuo.",
    price: "400,00",
    unit: "/mês",
    features: [
      "Diagnóstico inicial",
      "Planejamento personalizado",
      "Acompanhamento da evolução",
      "Orientação de estudos",
    ],
    href: "/mentorias-individuais",
  },
  {
    icon: "☏",
    title: "Correção com Feedback",
    subtitle: "Evolua com um olhar atento e construtivo.",
    desc: "Envio da sua redação para correção detalhada, com feedback individual e sugestões práticas para a sua evolução.",
    price: "89,90",
    unit: "/correção",
    features: [
      "Análise completa do texto",
      "Identificação dos erros",
      "Comentários detalhados",
      "Orientações para a próxima produção",
    ],
  },
];

export default function Modalities() {
  return (
    <>
      <ServiceHero
        eyebrow="NOSSAS MODALIDADES"
        title={
          <>
            Escolha a modalidade ideal para o seu <em>objetivo.</em>
          </>
        }
        description="Cada serviço é pensado para atender às suas necessidades, com um acompanhamento personalizado e focado na sua evolução."
        image="/images/modalidades-hero.png"
        // quote="Mais do que uma redação, é sobre realizar os seus objetivos!"
      />

      <main>
        <div className="container service-body">
          {/* <FeatureStrip
            items={features.map(([icon, label]) => ({ icon, label }))}
          /> */}

          <div className="service-grid">
            {services.map((s, i) => (
              <article className="service-card" key={s.title}>
                <div className="service-icon">{s.icon}</div>
                <h2>{s.title}</h2>
                <strong>{s.subtitle}</strong>
                <p>{s.desc}</p>
                <ul className="check-list">
                  {s.features.map((f) => (
                    <li key={f}>{f}</li>
                  ))}
                </ul>
                <div className="service-price">
                  R$ {s.price} <small>{s.unit}</small>
                </div>
                <ButtonHref
                  title = {s.title}
                  price = {s.price}
                  // href={s.href || wa(s.title)}
                  target={s.href ? "_self" : "_blank"}
                  className="btn-block"
                >
                  <FiShoppingCart /> &nbsp; COMPRAR AGORA
                </ButtonHref>
                {s.href && (
                  <a className="more" href={s.href}>
                    Saiba mais →
                  </a>
                )}
              </article>
            ))}
            <article className="contact-card">
              <div className="service-icon">◎</div>
              <h2>Ainda não tem certeza qual é a melhor opção?</h2>
              <p>
                Fale comigo pelo WhatsApp e receba uma orientação personalizada
                de acordo com o seu objetivo e momento.
              </p>
              <p>Prof. Iasmyn Souza Louis</p>
              <ButtonHref
                onClick={whatsAppRedirect}
                target="_blank"
              >
                <RiWhatsappLine /> &nbsp; Entrar em contato
              </ButtonHref>
            </article>
          </div>

          <InfoContractingTermsConditions />

          <section className="why" id="sobre">
            <SectionTitle
              align="center"
              title="Por que escolher o Escrita & Prática?"
            />
            <div className="why-grid">
              {[
                "Acompanhamento personalizado",
                "Metodologia comprovada",
                "Foco em resultados reais",
                "Experiência e comprometimento",
                "Feedback construtivo e contínuo",
              ].map((x, i) => (
                <div key={i}>
                  <b>{["♧", "▤", "▥", "☆", "☏"][i]}</b>
                  <span>{x}</span>
                </div>
              ))}
            </div>
          </section>
          <CTA />
          {/* <section id="depoimentos" className="simple-callout">
            <h2>Suas próximas conquistas começam com a escrita.</h2>
            <p>
              Escolha a modalidade que combina com seu objetivo e conte com
              acompanhamento para evoluir.
            </p>
          </section> */}
        </div>

        {/* section new  */}
        <div className="ep-container">
          {/* <SectionTitle
            eyebrow="Nossas soluções"
            title="Encontre a modalidade ideal para você"
            subtitle="As condições podem ser personalizadas de acordo com suas necessidades e objetivos."
          /> */}

          {/* <div className="ep-modality-grid">
            {modalidades.map((item) => (
              <article className="ep-modality-card" key={item.number}>
                <div className="ep-modality-card-number">{item.number}</div>
                <h3>{item.title}</h3>
                <span className="ep-modality-tag">{item.tag}</span>
                <p>{item.description}</p>

                <ul>
                  {item.items.map((feature) => (
                    <li key={feature}>{feature}</li>
                  ))}
                </ul>

                <div className="ep-modality-card-footer">
                  <Button>Quero conhecer</Button>
                </div>
              </article>
            ))}
          </div> */}
        </div>
        {/* section new  */}
      </main>
    </>
  );
}

// import { Link } from "react-router-dom";
// import React, { useState } from "react";
// import PurchaseModal from "../../components/purchase-modal";

// import SectionTitle from "../../components/elements/section-title";
// import Button from "../../components/elements/button";
// // import "../../styles/brand.css";
// import "./index-service-plan.css";

// // function Modalidades() {
// //   const [purchaseModalOpen, setPurchaseModalOpen] =
// //     useState(false);

// //   const [selectedProduct, setSelectedProduct] =
// //     useState(null);

// //   const handleBuy = (product) => {
// //     setSelectedProduct(product);
// //     setPurchaseModalOpen(true);
// //   };

// export default function Modalidades() {
//   return (
//     <div className="ep-page">
//       {/* <Header /> */}

//       <section className="ep-page-hero">
//         <div className="ep-container">
//           <div className="ep-page-hero-eyebrow">Aprenda com acompanhamento</div>
//           <h1>Modalidades para cada objetivo de escrita</h1>
//           <p>
//             Escolha o formato que mais combina com seu momento e receba
//             acompanhamento para evoluir com clareza, prática e feedback.
//           </p>
//         </div>
//       </section>

//       <main className="ep-section">
//         <div className="ep-container">
//           <SectionTitle
//             eyebrow="Nossas soluções"
//             title="Encontre a modalidade ideal para você"
//             subtitle="As condições podem ser personalizadas de acordo com suas necessidades e objetivos."
//           />

//         </div>
//       </main>

//     </div>
//   );
// }

// // import React, { useState } from "react";
// // import PurchaseModal from "../../components/PurchaseModal/PurchaseModal";

// // function Modalidades() {
// //   const [purchaseModalOpen, setPurchaseModalOpen] =
// //     useState(false);

// //   const [selectedProduct, setSelectedProduct] =
// //     useState(null);

// //   const handleBuy = (product) => {
// //     setSelectedProduct(product);
// //     setPurchaseModalOpen(true);
// //   };

// //   return (
// //     <>
// //       {/* Seu conteúdo da página */}

// //       <button
// //         onClick={() =>
// //           handleBuy({
// //             name: "Redação ENEM",
// //             description: "Preparação completa para o ENEM",
// //             price: 249.0,
// //           })
// //         }
// //       >
// //         Comprar agora
// //       </button>

// //       <button
// //         onClick={() =>
// //           handleBuy({
// //             name: "Mentorias Individuais",
// //             description: "Acompanhamento personalizado",
// //             price: 299.0,
// //           })
// //         }
// //       >
// //         Comprar agora
// //       </button>

// //       <PurchaseModal
// //         isOpen={purchaseModalOpen}
// //         onClose={() => setPurchaseModalOpen(false)}
// //         product={selectedProduct}
// //       />
// //     </>
// //   );
// // }
// // export default Modalidades;
